import { useNavigate, useParams } from "react-router-dom";
import { getItemSessionStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { Button, Col, Row } from "react-bootstrap";
import { FederalRoadInfoSection } from "../../../widgets/federalRoadInfoSection";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useDispatch } from "react-redux";
import { getGeoJSONFeaturesVectorLayer, getAllRoadObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { countExtentFromGeoJSONFeatures } from "../../../widgets/map/mapFeatures/helpers";
import { setPrintButtonIsClicked } from "../../../stateManagement/reducers/ContentHeaderSlice";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function FederalRoadInfoCard() {
    const { roadId } = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = useState<any>()
    const [contentHeaderType, setContentHeaderType] = useState<any>()
    const [mapState, setMapState] = useState<any>(null)
    const [printMapState, setPrintMapState] = useState<any>(null)
    const [mapEventHandlers, setMapEventHandlers] = useState<any>()
    const [additionalLayers, setAdditionalLayers] = useState<any>([])
    const [fitExtent, setFitExtent] = useState<any>();
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([]);
    const [permanentLayersMap] = useState([getAllRoadObjectsLayer()])
    const [permanentLayersPrintMap] = useState([getAllRoadObjectsLayer()])

    const federalRoads = getItemSessionStorage('featuresOnMapPoint')?.federalRoadFeatures ?? []
    const currentRoad = federalRoads?.filter((item: any) => item.id === 'OSMFederalRoads.' + roadId)[0]

    // флаг - индикация нажатия кнопки печати
    const printButtonIsClicked = useAppSelector(state => state.contentHeader.printButtonIsClicked)
    const printRef = useRef(null);
    // функция печати страницы информации
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: 'IndorGeo ' + `- ${currentRoad?.properties.PATHNAME}`,
        pageStyle: 'print'
    });

    // обработчик изменения флага-индикации нажатия кнопки печати
    if (printButtonIsClicked && currentRoad) {
        setTimeout(() => { handlePrint() }, 2000)
        dispatch(setPrintButtonIsClicked(false))
    }

    useEffect(() => {
        if (currentRoad) {
            setContentHeaderType('card')
            setName(currentRoad?.properties.PATHNAME)
            const federalRoadLayer = getGeoJSONFeaturesVectorLayer(currentRoad, "EPSG:4326")
            setAdditionalLayers([federalRoadLayer])
            const extent = countExtentFromGeoJSONFeatures(currentRoad)
            setFitExtent(extent)
            setFitExtentPadding([50, 50, 50, 50])
        } else {
            setName('Федеральная дорога')
        }
    }, [])

    useEffect(() => {
        function applySynchronizePrintMap(map: any) {
            const synchFunc = (event: any) => {
                if (mapState && printMapState) {
                    printMapState.getView().fit(mapState.getView().calculateExtent(), {
                        size: printMapState.getSize()
                    });
                }
            }
            map?.on("moveend", synchFunc)
            return {
                off: () => {
                    map?.un("moveend", synchFunc)
                }
            }
        }
        setMapEventHandlers(
            [
                {
                    name: "synchronizePrintMap",
                    func: applySynchronizePrintMap
                }
            ]
        )
    }, [mapState, printMapState])

    return (
        <>
            <ContentHeader title={name} type={contentHeaderType} option="federalRoad"/>
            <div className="federal-road-info-card-div" ref={printRef}>
                {currentRoad
                    ?
                    <>
                        <h5 className="print-title">Федеральная дорога</h5>
                        <div>
                            <FederalRoadInfoSection />
                        </div>
                        <div className="map-widget-federal-road-info">
                            <MapWidget
                                mapStateReturnFunc={(map: any) => setMapState(map)}
                                additionalLayers={additionalLayers}
                                permanentLayers={permanentLayersMap}
                                propsFitExtent={fitExtent}
                                propsFitExtentPadding={fitExtentPadding}
                                mapEventHandlers={mapEventHandlers}
                                mapInfoWidgetIsShown={false}
                                propsMinZoom={3}
                            />
                        </div>
                        <div className="map-to-print-div">
                            <div className="page-break" />
                            <MapWidget
                                target="federal-road-info-map-print"
                                mapStateReturnFunc={(map: any) => setPrintMapState(map)}
                                additionalLayers={additionalLayers}
                                permanentLayers={permanentLayersPrintMap}
                                propsFitExtent={fitExtent}
                                propsFitExtentPadding={fitExtentPadding}
                                mapSizeClass="federal-road-info-map-print"
                                mapInfoWidgetIsShown={false}
                                showMapLoader={false}
                                propsMinZoom={3}
                            />
                        </div>
                    </>
                    :
                    <div className="no-federal-road-info">
                        <Row>
                            <div className="section-name">Информация о федеральной дороге</div>
                            <div className="no-federal-road-text">
                                <span>Нет данных по федеральной дороге, выберите на карте:</span>
                            </div>
                            <Col>
                                <Button className="table-object-info-document-but on-map-but" onClick={() => navigate(`/app/map/AllRoadObjects`)}>
                                    Открыть карту
                                </Button>
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        </>
    )
}
